<template>
  <div id="app">
    <div class="container">
      <Game />
    </div>
  </div>
</template>

<script>
import Game from '@/views/Game.vue'
export default {
  name: 'App',
  components: {
    Game
  }
}
</script>

<style lang="scss" scoped>
#app{
  height: 100%;
}

.container{
  height: 100%;
}
</style>
